'use strict'
export function createCartazEngine(rootEl) {
  const root = {
    getElementById(id) {
      return rootEl.querySelector('[id="' + String(id).replace(/"/g, '\\"') + '"]')
    },
    querySelector(sel) {
      return rootEl.querySelector(sel)
    },
    querySelectorAll(sel) {
      return rootEl.querySelectorAll(sel)
    },
  }


'use strict';
const NS = 'http://www.w3.org/2000/svg';
const svg = root.getElementById('poster');
const status = root.getElementById('status');
const palettes = {
  neutro: {light:'#ffffff',mid:'#d6dce8',dark:'#8996a9',edge:'#fafcff',star:'#ffffff',font:'#e6edf8',medal:''},
  ouro:   {light:'#fff1a4',mid:'#ffba24',dark:'#aa5d00',edge:'#fbc151',star:'#ffd02b',font:'#ffde75',medal:'1º'},
  prata:  {light:'#ffffff',mid:'#c6cfde',dark:'#79879a',edge:'#e3e6ee',star:'#dce3ee',font:'#dce5f1',medal:'2º'},
  bronze: {light:'#ffe2bb',mid:'#c47743',dark:'#8d3c1e',edge:'#d99063',star:'#eaa06b',font:'#e5a475',medal:'3º'}
};
const ids=['nome','trimestre','percentual','ranking1','ranking2','ranking3','regular','suficiente','boa','otima'];
const FIXED_QR_URL='https://esusfeedback.com.br/cofinanciamento/ranking-regional';
let tema='ouro', urlValida=true, codigoIbgeExport='';
function node(tag,attrs={},parent){const el=document.createElementNS(NS,tag);for(const [k,v] of Object.entries(attrs))el.setAttribute(k,String(v));if(parent)parent.appendChild(el);return el;}
function polygon(cx,cy,r1,r2,steps){let parts=[];for(let i=0;i<steps*2;i++){const a=(i*Math.PI/steps)-Math.PI/2;const r=i%2===0?r1:r2;parts.push((i===0?'M':'L')+(cx+r*Math.cos(a)).toFixed(2)+' '+(cy+r*Math.sin(a)).toFixed(2));}return parts.join(' ')+'Z';}
// Medalhas e iconografia desenhadas matematicamente, sem imagens.
root.getElementById('sealScallop').setAttribute('d',polygon(146,123,66,61,21));
root.getElementById('blueRosette').setAttribute('d',polygon(0,0,26,22,12));
const laurel=root.getElementById('laurel');
for(let side of [-1,1])for(let i=0;i<9;i++){
  const a=(side<0 ? 140+i*9 : 40-i*9)*Math.PI/180;
  const x=146+38*Math.cos(a),y=124+39*Math.sin(a);
  node('ellipse',{cx:x.toFixed(1),cy:y.toFixed(1),rx:3.7,ry:7.8,transform:`rotate(${(a*180/Math.PI+90).toFixed(1)} ${x.toFixed(1)} ${y.toFixed(1)})`},laurel);
}
// Silhueta simplificada do Brasil, formada por coordenadas vetoriais (não é um mapa/imagem embutida).
const brazil=[[-57.6,-30.2],[-55.2,-27.9],[-53.6,-26.1],[-55.8,-22.4],[-57.9,-22.1],[-58.3,-17.3],[-60.5,-15.1],[-62.8,-13],[-65.4,-10.5],[-68.8,-11],[-72.6,-9.5],[-73.7,-6.9],[-72.9,-5.3],[-70.8,-4.3],[-69.4,-1.6],[-69.6,-.5],[-69.8,1.1],[-67.9,1.7],[-64.4,3.8],[-60.7,5.2],[-59.7,3.6],[-58.4,1.5],[-55.9,2],[-52.5,2.5],[-51.3,4.2],[-49.95,1],[-48.6,-.2],[-44.9,-1.6],[-41.5,-2.9],[-38.5,-3.7],[-35.6,-5.2],[-34.7,-7.3],[-35.6,-9.6],[-38.4,-13],[-38.9,-15.7],[-39.8,-19.6],[-42,-23],[-46.5,-24.1],[-48.5,-25.9],[-48.9,-28.7],[-51.6,-31.8],[-53.4,-33.8],[-56.9,-30.1]];
const outline=brazil.map(([lon,lat],i)=>`${i?'L':'M'}${(107+(lon+74)*18.9).toFixed(1)} ${(445+(5.5-lat)*15.8).toFixed(1)}`).join(' ');
root.getElementById('mapOutline').setAttribute('d',outline+'Z');
function val(id){return root.getElementById(id).value.trim();}
// v1.0.7: a classificação neutra mantém exatamente a tela e a arte anteriores.
// Nas classificações premiadas acrescentam-se apenas 96 unidades abaixo do título.
function shouldShowCIR(next=tema){
 return next!=='neutro' && root.getElementById('cirEnabled').checked;
}
function syncCIRLayout(next){
 const expanded=shouldShowCIR(next), added=expanded?96:0, height=1280+added;
 root.getElementById('cirCallToAction').style.display=expanded?'':'none';
 root.getElementById('cirMainPanel').setAttribute('height',String(656+added));
 root.getElementById('cirPaperWindow').setAttribute('height',String(656+added));
 // Fundo contínuo: estica a base e desce TODA a arte do rodapé junto com os logos.
 // Não usa overlay separado (era isso que criava a costura no meio do footer).
 const bgBase=root.getElementById('bgBase');
 const bgSky=root.getElementById('bgSky');
 if(bgBase)bgBase.setAttribute('height',String(height));
 if(bgSky)bgSky.setAttribute('height',String(height));
 const footerShift=`translate(0 ${added})`;
 root.getElementById('cirFooterContent').setAttribute('transform',footerShift);
 const footerAtmosphere=root.getElementById('footerAtmosphere');
 if(footerAtmosphere)footerAtmosphere.setAttribute('transform',footerShift);
 const footerBg=root.getElementById('cirFooterBackground');
 if(footerBg)footerBg.style.display='none';
 svg.setAttribute('viewBox',`0 0 953 ${height}`);
 svg.setAttribute('height',String(height));
 svg.style.aspectRatio=`953 / ${height}`;
 // Somente o formato ORIGINAL acompanha a ampliação; os oito formatos de destino mantêm suas medidas.
 exportFormats[0].height=height*3;
 const originalButton=root.querySelector('[data-export-format="original"]');
 if(originalButton){
  originalButton.querySelector('.export-choice-size').textContent=`2859 × ${height*3} px`;
  originalButton.setAttribute('aria-label',`Cartaz original, 2859 por ${height*3} pixels`);
 }
 exportCachedId=null;exportCachedJob=null;
 if(typeof exportOverlay!=='undefined'&&!exportOverlay.hidden)selectExportFormat(exportSelected);
}
function theme(next){tema=next;const t=palettes[next];svg.dataset.theme=next;
 svg.style.setProperty('--metal-light',t.light);svg.style.setProperty('--metal-mid',t.mid);svg.style.setProperty('--metal-dark',t.dark);svg.style.setProperty('--metal-edge',t.edge);svg.style.setProperty('--metal-star',t.star);svg.style.setProperty('--metal-font',t.font);
 root.getElementById('tColocacao').textContent=t.medal||'';
 root.querySelectorAll('[data-theme]').forEach(b=>{if(b!==svg)b.setAttribute('aria-pressed',String(b.dataset.theme===next));});
 svg.setAttribute('aria-label',`Cartaz de classificação ${next}, Vínculo, Acompanhamento e Indicadores de Qualidade na APS`);
 syncCIRLayout(next);
}
function fitText(el,text,maxWidth,baseFont,minFont=14){el.textContent=text||'—';let size=baseFont;el.setAttribute('font-size',size);while(size>minFont&&el.getComputedTextLength()>maxWidth){size-=.5;el.setAttribute('font-size',size);}}
// Nome do municipio: mantem o tamanho original e so quebra linha quando nao cabe.
function fitMunicipio(el,raw){
 const texto=String(raw||'—').trim().replace(/\s+/g,' ').toUpperCase();
 const centroX=475, centroY=140, larguraLinha=380, tamanho=33;
 el.removeAttribute('textLength');
 el.removeAttribute('lengthAdjust');
 el.setAttribute('text-anchor','middle');
 el.setAttribute('x',String(centroX));
 el.setAttribute('letter-spacing','0');
 el.setAttribute('font-size',String(tamanho));
 el.textContent=texto;

 const uf=texto.match(/^(.+?)\s+-\s+([A-Z]{2})$/);
 const palavras=(uf?uf[1]:texto).split(' ').filter(Boolean);
 if(uf&&palavras.length)palavras[palavras.length-1]+=' - '+uf[2];

 function medir(trecho){
  el.textContent=trecho;
  const w=el.getComputedTextLength();
  return w>1?w:trecho.length*tamanho*.55;
 }

 // Cabe em uma linha? Mantem tamanho e sai.
 if(medir(texto)<=larguraLinha){
  el.textContent=texto;
  el.setAttribute('y',String(centroY));
  return;
 }

 // Quebra por palavras no mesmo tamanho de fonte (sem reduzir).
 const linhas=[];
 let atual=[];
 palavras.forEach((palavra)=>{
  const tentativa=atual.length?[...atual,palavra].join(' '):palavra;
  if(atual.length&&medir(tentativa)>larguraLinha){
   linhas.push(atual.join(' '));
   atual=[palavra];
  }else{
   atual.push(palavra);
  }
 });
 if(atual.length)linhas.push(atual.join(' '));

 // Se alguma palavra isolada ainda estourar, deixa na propria linha (caso raro).
 el.replaceChildren();
 el.setAttribute('font-size',String(tamanho));
 const passo=tamanho*1.16;
 const inicio=centroY-(linhas.length-1)*passo/2;
 linhas.forEach((linha,i)=>{
  if(i>0)el.appendChild(document.createTextNode(' '));
  const tspan=node('tspan',{x:centroX,y:(inicio+i*passo).toFixed(2)},el);
  tspan.textContent=linha;
 });
}
function callout(el,raw,cx,cy,width=116,previousAreChecks=true){
 while(el.firstChild)el.removeChild(el.firstChild);
 const lines=raw.split(/\r?\n/).map(s=>s.trim()).filter(Boolean).slice(0,4);
 const isCheck=!lines.length&&previousAreChecks; if(isCheck)lines.push('✓✓');
 el.classList.toggle('is-check',isCheck);
 if(isCheck)el.removeAttribute('text-anchor');else el.setAttribute('text-anchor','start');
 const fontSize=lines.length>=4?17:lines.length===3?18:19;
 const lineH=fontSize+3,top=cy-(lines.length-1)*lineH/2;
 const x=isCheck?cx:cx-width/2+11;
 lines.forEach((line,i)=>{const text=node('tspan',{x,y:top+i*lineH},el);text.textContent=line;});
 el.setAttribute('font-size',fontSize);
 // Reduzir caso uma linha muito longa não caiba no balão.
 const maxTextWidth=isCheck?width:width-22;
 for(let size=fontSize;size>11&&lines.length&&Math.max(...Array.from(el.querySelectorAll('tspan'),span=>span.getComputedTextLength()))>maxTextWidth;size--)el.setAttribute('font-size',size);
}
// v1.0.5 — O fundo aprovado e suas paradas de gradiente continuam preservados.
// O único ajuste desta versão é a forma de escolher a cor (espectro + luminosidade + HEX).
const identityGradientIds=['bg','skyGlow','glassLight','footerBlue','cyanGlow','bannerNavy'];
const identityGradientStops=identityGradientIds.map(id=>[id,Array.from(root.querySelectorAll('#'+id+' stop'))]);
const identityOriginalStops=identityGradientStops.map(([id,stops])=>[id,stops.map(s=>s.getAttribute('stop-color'))]);
const identitySolidShapes=Array.from(svg.querySelectorAll('[data-identity-tone]'));
const identityOriginalShapes=identitySolidShapes.map(shape=>shape.getAttribute('fill'));
const ORIGINAL_PICKER_HEX='#065ED0';
let identitySelected='original',identityHex=ORIGINAL_PICKER_HEX;
const identityMessage=root.getElementById('identityMessage');
const identitySpectrum=root.getElementById('identitySpectrum');
const identityBrightness=root.getElementById('identityBrightness');
const identityCrosshair=root.getElementById('identityCrosshair');
const identityBrightnessArrow=root.getElementById('identityBrightnessArrow');
const identityColorHex=root.getElementById('identityColorHex');
const identityColorChip=root.getElementById('identityColorChip');
function identityNotice(message){if(identityMessage)identityMessage.textContent=message;}
function hexToRgb(hex){const n=parseInt(hex.slice(1),16);return [(n>>16)&255,(n>>8)&255,n&255];}
function rgbToHsl(r,g,b){r/=255;g/=255;b/=255;let max=Math.max(r,g,b),min=Math.min(r,g,b),d=max-min,h=0,s=0,l=(max+min)/2;
 if(d){s=d/(1-Math.abs(2*l-1));switch(max){case r:h=((g-b)/d)%6;break;case g:h=(b-r)/d+2;break;default:h=(r-g)/d+4;}h=((h*60)+360)%360;}return [h,s,l];}
function hslToHex(h,s,l){const a=s*Math.min(l,1-l);const f=n=>{const k=(n+h/30)%12;return Math.round((l-a*Math.max(-1,Math.min(k-3,9-k,1)))*255)};
 return '#'+[f(0),f(8),f(4)].map(n=>n.toString(16).padStart(2,'0')).join('');}
function paletteFor(hex){const [h,originalS,originalL]=rgbToHsl(...hexToRgb(hex));const sat=originalS<.13?.025:Math.min(.91,Math.max(.58,originalS*1.13));
 const top=Math.min(.44,Math.max(.33,.29+originalL*.27));
 const tone=(l,boost=1)=>hslToHex(h,Math.min(.96,sat*boost),l);
 return {bg:[tone(top),tone(top-.045),tone(top-.10),tone(.18,.94)],skyGlow:[tone(.72,.70),tone(.45,.9)],glassLight:[tone(.87,.5),tone(.79,.4),tone(.79,.3)],
 footerBlue:[tone(.32,.91),tone(.22,.9),tone(.145,.94),tone(.095,.9)],cyanGlow:['#ffffff',tone(.77,.66),tone(.60,.96),tone(.56,.96)],
 bannerNavy:[tone(.11,.95),tone(.22,.96),tone(.30,1),tone(.15,.96)],
 solid:[tone(top+.02),tone(top+.04,.88),tone(.27,.92),tone(.21,.93)]};
}
function restoreOriginalBackground(){identityGradientStops.forEach(([id,stops],i)=>stops.forEach((s,j)=>s.setAttribute('stop-color',identityOriginalStops[i][1][j])));
 identitySolidShapes.forEach((shape,i)=>shape.setAttribute('fill',identityOriginalShapes[i]));}
function applyIdentityBackground(){
 const sample=root.getElementById('identityGradientSample');
 if(identitySelected==='original'){
  restoreOriginalBackground();
  if(sample)sample.style.background='linear-gradient(120deg,#0878d5,#065ed0,#1152c0,#06246f)';
  return;
 }
 const palette=paletteFor(identityHex);
 identityGradientStops.forEach(([id,stops])=>{const colors=palette[id];if(colors)stops.forEach((s,i)=>s.setAttribute('stop-color',colors[i]));});
 identitySolidShapes.forEach((shape,i)=>shape.setAttribute('fill',palette.solid[i]));
 if(sample)sample.style.background=`linear-gradient(120deg,${palette.bg.join(',')})`;
}
function rgbToHsv(r,g,b){r/=255;g/=255;b/=255;
 const max=Math.max(r,g,b),min=Math.min(r,g,b),delta=max-min;
 let h=0;if(delta){switch(max){case r:h=((g-b)/delta)%6;break;case g:h=(b-r)/delta+2;break;default:h=(r-g)/delta+4;}}
 return [((h*60)+360)%360,max===0?0:delta/max,max];
}
function hsvToHex(h,s,v){const c=v*s,x=c*(1-Math.abs((h/60)%2-1)),m=v-c;
 const parts=h<60?[c,x,0]:h<120?[x,c,0]:h<180?[0,c,x]:h<240?[0,x,c]:h<300?[x,0,c]:[c,0,x];
 return '#'+parts.map(n=>Math.round((n+m)*255).toString(16).padStart(2,'0')).join('').toUpperCase();
}
let [identityHue,identitySat,identityVal]=rgbToHsv(...hexToRgb(ORIGINAL_PICKER_HEX));
function updateIdentityPicker(){
 identityCrosshair.style.left=(identityHue/360*100)+'%';
 identityCrosshair.style.top=((1-identitySat)*100)+'%';
 identityBrightnessArrow.style.top=((1-identityVal)*100)+'%';
 identityBrightness.style.background=`linear-gradient(to bottom,${hsvToHex(identityHue,identitySat,1)} 0%,#000000 100%)`;
 identityBrightness.setAttribute('aria-valuenow',String(Math.round(identityVal*100)));
 identityBrightness.setAttribute('aria-valuetext',Math.round(identityVal*100)+'% de luminosidade');
 identityColorHex.value=identityHex;
 identityColorHex.setAttribute('aria-invalid','false');
 identityColorChip.style.background=identityHex;
}
function selectIdentityHex(hex){
 if(!/^#[\da-f]{6}$/i.test(hex))return false;
 identityHex=hex.toUpperCase();
 [identityHue,identitySat,identityVal]=rgbToHsv(...hexToRgb(identityHex));
 identitySelected='custom';applyIdentityBackground();updateIdentityPicker();
 identityNotice('Cor '+identityHex+' aplicada ao fundo, município, 100% e competência.');
 return true;
}
function updateIdentityByPointer(){
 identityHex=hsvToHex(identityHue,identitySat,identityVal);
 identitySelected='custom';applyIdentityBackground();updateIdentityPicker();
 identityNotice('Cor '+identityHex+' aplicada ao fundo, município, 100% e competência.');
}
function relativePosition(el,event){const rect=el.getBoundingClientRect();return {
 x:Math.max(0,Math.min(1,(event.clientX-rect.left)/(rect.width||1))),
 y:Math.max(0,Math.min(1,(event.clientY-rect.top)/(rect.height||1)))
};}
function attachIdentityPointer(el,update){
 el.addEventListener('pointerdown',event=>{if(!event.isPrimary)return;event.preventDefault();el.setPointerCapture(event.pointerId);update(event);});
 el.addEventListener('pointermove',event=>{if(el.hasPointerCapture(event.pointerId))update(event);});
 el.addEventListener('pointerup',event=>{if(el.hasPointerCapture(event.pointerId))el.releasePointerCapture(event.pointerId);});
 el.addEventListener('pointercancel',event=>{if(el.hasPointerCapture(event.pointerId))el.releasePointerCapture(event.pointerId);});
}
attachIdentityPointer(identitySpectrum,event=>{const p=relativePosition(identitySpectrum,event);identityHue=Math.min(359.999,p.x*360);identitySat=1-p.y;updateIdentityByPointer();});
attachIdentityPointer(identityBrightness,event=>{const p=relativePosition(identityBrightness,event);identityVal=1-p.y;updateIdentityByPointer();});
identitySpectrum.addEventListener('keydown',event=>{
 const delta=event.shiftKey?10:2;
 if(event.key==='ArrowLeft')identityHue=Math.max(0,identityHue-delta);
 else if(event.key==='ArrowRight')identityHue=Math.min(359.999,identityHue+delta);
 else if(event.key==='ArrowUp')identitySat=Math.min(1,identitySat+delta/100);
 else if(event.key==='ArrowDown')identitySat=Math.max(0,identitySat-delta/100);
 else return;
 event.preventDefault();updateIdentityByPointer();
});
identityBrightness.addEventListener('keydown',event=>{
 const delta=event.shiftKey?.10:.02;
 if(event.key==='ArrowUp'||event.key==='ArrowRight')identityVal=Math.min(1,identityVal+delta);
 else if(event.key==='ArrowDown'||event.key==='ArrowLeft')identityVal=Math.max(0,identityVal-delta);
 else if(event.key==='Home')identityVal=1;
 else if(event.key==='End')identityVal=0;
 else return;
 event.preventDefault();updateIdentityByPointer();
});
identityColorHex.addEventListener('input',()=>{
 const color=identityColorHex.value.trim();
 if(/^#[\da-f]{6}$/i.test(color))selectIdentityHex(color);
 else identityColorHex.setAttribute('aria-invalid','true');
});
identityColorHex.addEventListener('blur',()=>{
 if(!/^#[\da-f]{6}$/i.test(identityColorHex.value.trim()))updateIdentityPicker();
});
function resetIdentityBackground(){identitySelected='original';identityHex=ORIGINAL_PICKER_HEX;
 [identityHue,identitySat,identityVal]=rgbToHsv(...hexToRgb(ORIGINAL_PICKER_HEX));
 applyIdentityBackground();updateIdentityPicker();identityNotice('Azul original ativo.');
}
root.getElementById('identityReset').addEventListener('click',resetIdentityBackground);
updateIdentityPicker();
// QR Code 100% local (padrão ISO/IEC 18004, versão 5 nível L, byte-mode), sem CDNs ou imagens.
function createQr(value){
 const bytes=new TextEncoder().encode(value), size=37, dataCount=108, eccCount=26;
 if(bytes.length>106)throw Error('O endereço do QR Code é longo demais. Use uma URL de até 106 bytes.');
 const bits=[];function pushBits(v,n){for(let i=n-1;i>=0;i--)bits.push((v>>>i)&1);}
 pushBits(4,4);pushBits(bytes.length,8);for(const b of bytes)pushBits(b,8);
 for(let i=0;i<4&&bits.length<dataCount*8;i++)bits.push(0);
 while(bits.length%8!==0)bits.push(0);
 const data=[];for(let i=0;i<bits.length;i+=8){let b=0;for(let j=0;j<8;j++)b=(b<<1)|bits[i+j];data.push(b);}
 while(data.length<dataCount)data.push(data.length%2===0?0xec:0x11);
 function gfMul(a,b){let z=0;for(let i=7;i>=0;i--){z=(z<<1)^((z&0x80)?0x11d:0);z^=((b>>>i)&1)?a:0;}return z;}
 const divisor=Array(eccCount).fill(0);divisor[eccCount-1]=1;
 for(let i=0,root=1;i<eccCount;i++){for(let j=0;j<eccCount;j++){divisor[j]=gfMul(divisor[j],root);if(j+1<eccCount)divisor[j]^=divisor[j+1];}root=gfMul(root,2);}
 const ecc=Array(eccCount).fill(0);for(const b of data){const factor=b^ecc.shift();ecc.push(0);for(let j=0;j<eccCount;j++)ecc[j]^=gfMul(divisor[j],factor);}
 const codewords=data.concat(ecc),matrix=Array.from({length:size},()=>Array(size).fill(null)),func=Array.from({length:size},()=>Array(size).fill(false));
 function set(x,y,dark){if(x>=0&&y>=0&&x<size&&y<size){matrix[y][x]=!!dark;func[y][x]=true;}}
 function finder(x,y){for(let dy=-1;dy<=7;dy++)for(let dx=-1;dx<=7;dx++){let dark=dx>=0&&dx<=6&&dy>=0&&dy<=6&&(dx===0||dx===6||dy===0||dy===6||(dx>=2&&dx<=4&&dy>=2&&dy<=4));set(x+dx,y+dy,dark);}}
 finder(0,0);finder(size-7,0);finder(0,size-7);
 for(let i=8;i<size-8;i++){set(i,6,i%2===0);set(6,i,i%2===0);}
 for(let dy=-2;dy<=2;dy++)for(let dx=-2;dx<=2;dx++)set(30+dx,30+dy,Math.max(Math.abs(dx),Math.abs(dy))!==1);
 // Reservar bits de formato em ambas as cópias.
 for(let i=0;i<=5;i++)set(8,i,false);set(8,7,false);set(8,8,false);set(7,8,false);
 for(let i=9;i<=14;i++)set(14-i,8,false);
 for(let i=0;i<=7;i++)set(size-1-i,8,false);
 for(let i=8;i<=14;i++)set(8,size-15+i,false);
 set(8,size-8,true);
 const dataBits=[];for(const word of codewords)for(let i=7;i>=0;i--)dataBits.push((word>>>i)&1);
 let k=0;
 for(let right=size-1;right>=1;right-=2){if(right===6)right=5;for(let vert=0;vert<size;vert++){
 const up=((right+1)&2)===0,y=up?size-1-vert:vert;
 for(let j=0;j<2;j++){const x=right-j;if(!func[y][x])matrix[y][x]=(k<dataBits.length?dataBits[k++]:0)!==0;}
 }}
 // Oito máscaras regulamentares; escolhe-se a de menor penalização.
 const masks=[(x,y)=>(x+y)%2===0,(x,y)=>y%2===0,(x,y)=>x%3===0,(x,y)=>(x+y)%3===0,
 (x,y)=>(Math.floor(y/2)+Math.floor(x/3))%2===0,(x,y)=>((x*y)%2+(x*y)%3)===0,
 (x,y)=>((x*y)%2+(x*y)%3)%2===0,(x,y)=>((x+y)%2+(x*y)%3)%2===0];
 function drawFormat(m,mask){const dataFmt=(1<<3)|mask;let rem=dataFmt;for(let i=0;i<10;i++)rem=(rem<<1)^(((rem>>>9)&1)*0x537);const format=((dataFmt<<10)|rem)^0x5412;const bit=i=>((format>>>i)&1)!==0;
 for(let i=0;i<=5;i++)m[i][8]=bit(i);m[7][8]=bit(6);m[8][8]=bit(7);m[8][7]=bit(8);
 for(let i=9;i<=14;i++)m[8][14-i]=bit(i);
 for(let i=0;i<=7;i++)m[8][size-1-i]=bit(i);
 for(let i=8;i<=14;i++)m[size-15+i][8]=bit(i);
 m[size-8][8]=true;
 }
 function score(m){let penalty=0;
 for(let y=0;y<size;y++)for(let x=0;x<size;x++){let col=m[y][x];if(x+1<size&&y+1<size&&col===m[y][x+1]&&col===m[y+1][x]&&col===m[y+1][x+1])penalty+=3;}
 for(let i=0;i<size;i++)for(let axis=0;axis<2;axis++){let seq=Array.from({length:size},(_,j)=>axis===0?m[i][j]:m[j][i]);let last=seq[0],run=1;for(let j=1;j<size;j++){if(seq[j]===last)run++;else{if(run>=5)penalty+=3+run-5;last=seq[j];run=1;}}if(run>=5)penalty+=3+run-5;
  for(let j=0;j+10<size;j++){const chunk=seq.slice(j,j+11).map(x=>x?1:0).join('');if(chunk==='10111010000'||chunk==='00001011101')penalty+=40;}}
 const dark=m.flat().filter(Boolean).length;penalty+=Math.floor(Math.abs(dark*20-size*size*10)/(size*size))*10;return penalty;
 }
 let best=null,bestScore=Infinity;
 for(let mask=0;mask<8;mask++){let m=matrix.map(a=>a.slice());for(let y=0;y<size;y++)for(let x=0;x<size;x++)if(!func[y][x]&&m[y][x]&&masks[mask](x,y))m[y][x]=false;else if(!func[y][x]&&masks[mask](x,y))m[y][x]=!m[y][x];drawFormat(m,mask);let s=score(m);if(s<bestScore){bestScore=s;best=m;}}
 return best;
}
function renderQr(value){const group=root.getElementById('qrGrid');while(group.firstChild)group.removeChild(group.firstChild);
 const qr=createQr(value);const scale=105/45;group.setAttribute('transform',`translate(791 1125) scale(${scale})`);
 let d='';for(let y=0;y<qr.length;y++)for(let x=0;x<qr.length;x++)if(qr[y][x])d+=`M${x+4} ${y+4}h1v1h-1Z`;
 node('path',{d,fill:'#070b0f'},group);
}
// A URL permanece inalterada; somente a representacao no cartaz recebe o espaco.
function formatarCompetencia(valor){return String(valor??'').trim().toUpperCase().replace(/^(\d{4})\s*(Q\d+)$/, '$1 $2');}
function formatarPercentual(valor){
 const cleaned=String(valor??'').replace('%','').trim().replace(',','.');
 const n=Number(cleaned);
 if(!cleaned||isNaN(n))return '—';
 const arredondado=Math.round(n*100)/100;
 return String(arredondado).replace('.',',');
}
// Reduz a fonte do percentual para caber no selo circular interno (r≈53, com folga da borda).
function fitPercentual(el,raw){
 const show=formatarPercentual(raw);
 // Diâmetro útil ~78px para não encostar no anel dourado.
 const maxWidth=78;
 let baseFont=show.length>=6?28:show.length>=5?30:show.length>=4?36:41;
 let pctFont=Math.round(baseFont*.52);
 const minBase=18;
 while(el.firstChild)el.removeChild(el.firstChild);
 el.setAttribute('text-anchor','middle');
 el.setAttribute('x','809');
 el.removeAttribute('letter-spacing');
 el.setAttribute('font-size',String(baseFont));
 el.appendChild(document.createTextNode(show));
 const span=node('tspan',{'font-size':String(pctFont)},el);
 span.textContent='%';
 while(baseFont>minBase&&el.getComputedTextLength()>maxWidth){
  baseFont-=.5;
  pctFont=Math.max(11,Math.round(baseFont*.52));
  el.setAttribute('font-size',String(baseFont));
  span.setAttribute('font-size',String(pctFont));
 }
 if(el.getComputedTextLength()>maxWidth){
  el.setAttribute('letter-spacing','-0.6');
 }
 // Centrado verticalmente abaixo das estrelas.
 el.setAttribute('y',String(132+baseFont*.32));
}
function parseRankingDisplay(raw,index){
 const texto=String(raw||'').trim()||'—';
 const partes=texto.match(/^(\d+º)\s*(.*)$/);
 const numero=partes?partes[1]:texto;
 const resto=(partes?partes[2]:'').replace(/^(na|no)\s+/i,'').trim();
 if(index===0)return {numero,label:'Regional'};
 if(index===1)return {numero,label:resto?`Estado ${resto}`:'Estado'};
 if(/^BR\b/i.test(resto))return {numero,label:resto.replace(/^BR/i,'Brasil')};
 return {numero,label:resto||'Brasil'};
}
function layoutRankingCards(){
 // 120 no SVG ≈ ~65px na tela do modal (o preview escala o cartaz).
 const MIN_CARD_W=120;
 const cardY=-6, cardH=40, padX=16, maxW=200;
 const midY=cardY+cardH/2;
 const items=[];
 for(let i=0;i<3;i++){
  const numEl=root.getElementById('tRanking'+(i+1));
  if(!numEl)continue;
  const group=numEl.parentNode;
  const parsed=parseRankingDisplay(val('ranking'+(i+1)),i);
  items.push({
   index:i,
   numEl,
   group,
   labelEl:root.getElementById('tRanking'+(i+1)+'Label')||(group&&group.querySelector('.rank-title')),
   cardEl:root.getElementById('tRanking'+(i+1)+'Card')||(group&&group.querySelector('rect.rank-card,rect')),
   numero:parsed.numero,
   label:parsed.label
  });
 }
 if(!items.length)return;

 let maxTextW=0;
 items.forEach(item=>{
  const digitos=(item.numero.match(/\d/g)||[]).length;
  item.baseNum=digitos>=4?18:digitos===3?20:digitos===2?24:26;
  fitText(item.numEl,item.numero,maxW,item.baseNum,item.baseNum);
  item.numEl.setAttribute('x','0');
  item.numEl.setAttribute('y',String(midY));
  item.numEl.setAttribute('text-anchor','middle');
  item.numEl.setAttribute('dominant-baseline','central');
  item.numEl.setAttribute('alignment-baseline','central');
  const tw=item.numEl.getComputedTextLength();
  if(tw>maxTextW)maxTextW=tw;
 });

 // Largura compartilhada: nunca menor que 65.
 let cardW=maxTextW+padX*2;
 if(!isFinite(cardW)||cardW<MIN_CARD_W)cardW=MIN_CARD_W;
 if(cardW>maxW)cardW=maxW;
 cardW=Math.round(cardW);
 const innerW=Math.max(24,cardW-padX*2);

 items.forEach(item=>{
  fitText(item.numEl,item.numero,innerW,item.baseNum,11);
  if(item.cardEl){
   item.cardEl.setAttribute('x',String(-cardW/2));
   item.cardEl.setAttribute('y',String(cardY));
   item.cardEl.setAttribute('width',String(cardW));
   item.cardEl.setAttribute('height',String(cardH));
   item.cardEl.setAttribute('rx','12');
   // Garante mínimo mesmo se algo alterar cardW depois.
   if(Number(item.cardEl.getAttribute('width'))<MIN_CARD_W){
    item.cardEl.setAttribute('width',String(MIN_CARD_W));
    item.cardEl.setAttribute('x',String(-MIN_CARD_W/2));
   }
  }
  if(item.labelEl){
   fitText(item.labelEl,item.label,Math.max(220,cardW+20),16,11);
   item.labelEl.setAttribute('x','0');
   item.labelEl.setAttribute('y',String(cardY-10));
   item.labelEl.setAttribute('text-anchor','middle');
  }
 });

 const y=258, span=460, start=(953-span)/2, step=span/2;
 items.forEach((item,i)=>{
  if(item.group)item.group.setAttribute('transform',`translate(${start+step*i} ${y})`);
 });
}
function render(){
 fitMunicipio(root.getElementById('tMunicipio'),val('nome'));
 fitText(root.getElementById('tTrimestre'),formatarCompetencia(val('trimestre')),205,34,20);
 fitPercentual(root.getElementById('tPercentual'),val('percentual'));
 layoutRankingCards();
 const baloes=[
  ['tRegular','regular',189,686],
  ['tSuficiente','suficiente',381,642],
  ['tBoa','boa',569,586],
  ['tOtima','otima',768,528]
 ];
 let anterioresSaoChecks=true;
 baloes.forEach(([id,campo,cx,cy])=>{
  const conteudo=val(campo);
  callout(root.getElementById(id),conteudo,cx,cy,116,anterioresSaoChecks);
  if(conteudo)anterioresSaoChecks=false;
 });
 root.getElementById('mapOutline').style.visibility=root.getElementById('mapa').checked?'visible':'hidden';
 root.getElementById('starLabels').style.display=root.getElementById('legendas').checked?'':'none';
 try{renderQr(FIXED_QR_URL);urlValida=true;if(status.classList.contains('error'))status.textContent='';status.classList.remove('error');}catch(e){urlValida=false;status.textContent=e.message;status.classList.add('error');}
}
function filename(ext){
 const ibge=String(codigoIbgeExport||'').replace(/\D/g,'')||'0000000';
 const quad=String(val('trimestre')||'').trim().toUpperCase().replace(/\s+/g,'').replace(/[^0-9A-Z]/g,'')||'0000Q0';
 return `RES_MUN_${ibge}_${quad}.${ext}`;
}
function serializeSvg(){
 const c=svg.cloneNode(true);
 c.removeAttribute('aria-label');
 c.setAttribute('xmlns','http://www.w3.org/2000/svg');
 c.setAttribute('xmlns:xlink','http://www.w3.org/1999/xlink');
 c.setAttribute('width','953');
 c.setAttribute('height',svg.getAttribute('height'));
 c.setAttribute('viewBox',svg.getAttribute('viewBox'));
 return new XMLSerializer().serializeToString(c);
}
function downloadFile(blob,name){const a=document.createElement('a'),url=URL.createObjectURL(blob);a.href=url;a.download=name;document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),2000);}
function announce(msg,err=false){status.textContent=msg;status.classList.toggle('error',err);}
root.getElementById('btnSvg').addEventListener('click',()=>{
 if(!urlValida){announce('Corrija o endereço do QR Code antes de baixar.',true);exportStatus.textContent='Corrija o endereço do QR Code antes de baixar SVG.';exportStatus.classList.add('error');return;}
 try{downloadFile(new Blob([serializeSvg()],{type:'image/svg+xml;charset=utf-8'}),filename('svg'));announce('SVG pronto.');exportStatus.textContent='SVG vetorial pronto.';exportStatus.classList.remove('error');}
 catch(e){announce('Não foi possível exportar SVG.',true);exportStatus.textContent='Falha ao gerar SVG.';exportStatus.classList.add('error');console.error(e);}
});
// v1.0.6: assistente de exportação multiuso, sem alterar SVG ou demais funções.
const exportFormats=Object.freeze([
 {id:'original',name:'Cartaz original',width:2859,height:3840,icon:'image',desc:'Alta resolução e todas as informações, incluindo a mensagem à CIR quando ela estiver ativada.'},
 {id:'slide',name:'Apresentação',width:1920,height:1080,icon:'presentation',desc:'Horizontal 16:9 para PowerPoint e Google Slides.'},
 {id:'site',name:'Página do site',width:1200,height:1600,icon:'globe',desc:'Vertical para exibição dentro de páginas de um site.'},
 {id:'youtube',name:'Capa do YouTube',width:1280,height:720,icon:'youtube',desc:'Miniatura horizontal 16:9 para vídeos no YouTube.'},
 {id:'whatsapp',name:'WhatsApp',width:1080,height:1440,icon:'message',desc:'Cartaz vertical para enviar em conversas do WhatsApp.'},
 {id:'status',name:'Status WhatsApp',width:1080,height:1920,icon:'phone',desc:'Formato vertical 9:16 para o Status do WhatsApp.'},
 {id:'instagram',name:'Instagram Feed',width:1080,height:1350,icon:'instagram',desc:'Publicação vertical 4:5 para o feed do Instagram.'},
 {id:'stories',name:'Instagram Stories',width:1080,height:1920,icon:'phone',desc:'Formato vertical 9:16 para Stories do Instagram.'},
 {id:'email',name:'E-mail',width:1200,height:1600,icon:'mail',desc:'Cartaz vertical para anexar ou inserir em um e-mail.'}
]);
const exportIconPaths={
 image:'<rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m4 18 5-5 4 4 3-3 4 4"/>',
 presentation:'<rect x="3" y="3" width="18" height="13" rx="1.5"/><path d="M12 16v5m-5 0h10M8 11l3-3 2 2 3-3"/>',
 globe:'<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c-3 3-3 15 0 18M12 3c3 3 3 15 0 18"/>',
 youtube:'<rect x="2" y="5" width="20" height="14" rx="4"/><path d="m10 9 5 3-5 3z"/>',
 message:'<path d="M20 11a8 8 0 0 1-8 8 9 9 0 0 1-4-.9L3 20l1.9-5A8 8 0 1 1 20 11Z"/><path d="M9 10c1 2 3 3 5 4"/>',
 phone:'<rect x="6" y="2" width="12" height="20" rx="2"/><path d="M11 18h2"/>',
 instagram:'<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1"/>',
 mail:'<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m3 6 9 7 9-7"/>'
};
const exportOverlay=root.getElementById('exportOverlay');
const exportDialog=root.getElementById('exportDialog');
const exportChoices=root.getElementById('exportChoices');
const exportPreviewFrame=root.getElementById('exportPreviewFrame');
const exportPreviewImage=root.getElementById('exportPreviewImage');
const exportStatus=root.getElementById('exportStatus');
const exportGenerate=root.getElementById('exportGenerate');
const exportShare=root.getElementById('exportShare');
let exportSelected='original',exportPreviewUrl=null,exportReturnFocus=null,exportBusy=false;
let exportCachedId=null,exportCachedJob=null;

for(const format of exportFormats){
 const btn=document.createElement('button');btn.type='button';btn.className='export-choice';btn.dataset.exportFormat=format.id;
 btn.setAttribute('aria-pressed','false');btn.setAttribute('aria-label',`${format.name}, ${format.width} por ${format.height} pixels`);
 btn.innerHTML=`<span class="export-choice-title"><svg class="export-choice-icon" viewBox="0 0 24 24" aria-hidden="true">${exportIconPaths[format.icon]}</svg><span>${format.name}</span></span><span class="export-choice-size">${format.width} × ${format.height} px</span><span class="export-choice-mark" aria-hidden="true">✓</span>`;
 btn.addEventListener('click',()=>selectExportFormat(format.id));exportChoices.appendChild(btn);
}
function exportGradientColors(){return Array.from(svg.querySelectorAll('#bg stop'),s=>s.getAttribute('stop-color'));}
function exportGradientCss(){return `linear-gradient(140deg,${exportGradientColors().join(',')})`;}
// v1.0.19: maximiza a pré-visualização no espaço da lista de formatos, sem cortar o cartaz.
function fitExportPreview(format){
 if(exportOverlay.hidden)return;
 const panel=root.querySelector('.export-preview-panel');
 if(window.matchMedia('(max-width:700px)').matches){
  panel.style.setProperty('--preview-matched-height',`${Math.ceil(exportChoices.getBoundingClientRect().height)}px`);
 }else panel.style.removeProperty('--preview-matched-height');
 const style=getComputedStyle(panel);
 const maxWidth=Math.max(1,panel.clientWidth-parseFloat(style.paddingLeft)-parseFloat(style.paddingRight));
 const maxHeight=Math.max(1,panel.clientHeight-parseFloat(style.paddingTop)-parseFloat(style.paddingBottom));
 const scale=Math.min(maxWidth/format.width,maxHeight/format.height);
 exportPreviewFrame.style.width=`${format.width*scale}px`;
 exportPreviewFrame.style.height=`${format.height*scale}px`;
}
function selectExportFormat(id){
 const format=exportFormats.find(item=>item.id===id);if(!format)return;
 exportSelected=id;
 exportChoices.querySelectorAll('.export-choice').forEach(btn=>btn.setAttribute('aria-pressed',String(btn.dataset.exportFormat===id)));
 fitExportPreview(format);
 exportStatus.textContent='';exportStatus.classList.remove('error');
 if(!exportOverlay.hidden&&exportShareSupported)prepareExportShare(format);
}
window.addEventListener('resize',()=>{
 if(exportOverlay.hidden)return;
 const format=exportFormats.find(item=>item.id===exportSelected);
 if(format)fitExportPreview(format);
});
const exportShareSupported=(()=>{
 if(typeof navigator.share!=='function'||typeof navigator.canShare!=='function'||typeof File==='undefined')return false;
 try{return navigator.canShare({files:[new File(['a'],'teste.png',{type:'image/png'})]});}catch(e){return false;}
})();
exportShare.hidden=!exportShareSupported;
function openExportDialog(){
 setPosterMenu(false);
 if(!urlValida){announce('Corrija o endereço do QR Code antes de baixar.',true);return;}
 exportReturnFocus=document.activeElement;
 exportPreviewUrl=URL.createObjectURL(new Blob([serializeSvg()],{type:'image/svg+xml;charset=utf-8'}));
 exportPreviewImage.src=exportPreviewUrl;
 exportPreviewFrame.style.background=exportGradientCss();
 exportOverlay.hidden=false;document.body.classList.add('export-locked');
 selectExportFormat(exportSelected);
 exportDialog.focus();
}
function closeExportDialog(){
 if(exportBusy)return;
 exportOverlay.hidden=true;document.body.classList.remove('export-locked');
 exportPreviewImage.removeAttribute('src');
 if(exportPreviewUrl){URL.revokeObjectURL(exportPreviewUrl);exportPreviewUrl=null;}
 exportCachedId=null;exportCachedJob=null;
 if(exportReturnFocus&&typeof exportReturnFocus.focus==='function')exportReturnFocus.focus();
}
function formatExportFilename(format){
 const base=filename('png');
 return format.id==='original'?base:base.slice(0,-4)+`-${format.id}-${format.width}x${format.height}.png`;
}
async function renderExportPng(format){
 const uri=URL.createObjectURL(new Blob([serializeSvg()],{type:'image/svg+xml;charset=utf-8'}));
 try{
  const sourceHeight=Number(svg.getAttribute('height'));
  const img=new Image();img.width=953;img.height=sourceHeight;
  await new Promise((resolve,reject)=>{img.onload=resolve;img.onerror=()=>reject(new Error('Falha ao converter SVG.'));img.src=uri;});
  const canvas=document.createElement('canvas');canvas.width=format.width;canvas.height=format.height;
  const ctx=canvas.getContext('2d');if(!ctx)throw new Error('Canvas não disponível neste dispositivo.');
  // O cartaz é sempre encaixado INTEIRO: não há corte, distorção ou alteração do SVG.
  const gradient=ctx.createLinearGradient(0,0,format.width*.85,format.height);
  exportGradientColors().forEach((color,i)=>gradient.addColorStop([0,.35,.75,1][i],color));
  ctx.fillStyle=gradient;ctx.fillRect(0,0,format.width,format.height);
  const scale=Math.min(format.width/953,format.height/sourceHeight);
  const width=953*scale,height=sourceHeight*scale;
  ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';
  ctx.drawImage(img,(format.width-width)/2,(format.height-height)/2,width,height);
  return await new Promise((resolve,reject)=>canvas.toBlob(blob=>blob?resolve(blob):reject(new Error('PNG não gerado.')),'image/png'));
 }finally{URL.revokeObjectURL(uri);}
}
function getExportBlob(format){
 if(exportCachedId===format.id&&exportCachedJob)return exportCachedJob;
 exportCachedId=format.id;
 exportCachedJob=renderExportPng(format).catch(e=>{if(exportCachedId===format.id){exportCachedId=null;exportCachedJob=null;}throw e;});
 return exportCachedJob;
}
async function prepareExportShare(format){
 if(!exportShareSupported)return;
 exportShare.disabled=true;
 exportShare.textContent='Preparando…';
 try{
  const blob=await getExportBlob(format);
  if(exportOverlay.hidden||exportSelected!==format.id)return;
  const file=new File([blob],formatExportFilename(format),{type:'image/png'});
  if(!navigator.canShare({files:[file]}))throw new Error('O compartilhamento deste arquivo não é compatível com o navegador.');
  exportShare.disabled=false;exportShare.textContent='Compartilhar';
 }catch(e){
  if(!exportOverlay.hidden&&exportSelected===format.id){exportShare.textContent='Indisponível';exportStatus.textContent='Use Baixar PNG neste dispositivo.';}
 }
}
function exportSetBusy(busy){
 exportBusy=busy;exportGenerate.disabled=busy;root.getElementById('exportCancel').disabled=busy;
 root.getElementById('btnSvg').disabled=busy;
 root.getElementById('exportClose').disabled=busy;
 exportChoices.querySelectorAll('button').forEach(btn=>btn.disabled=busy);
 if(exportShareSupported)exportShare.disabled=busy;
}
exportGenerate.addEventListener('click',async()=>{
 const format=exportFormats.find(f=>f.id===exportSelected);if(!format||exportBusy)return;
 exportSetBusy(true);exportGenerate.textContent='Gerando PNG…';exportStatus.textContent='Preparando arquivo em alta qualidade…';
 try{
  const blob=await getExportBlob(format);downloadFile(blob,formatExportFilename(format));
  exportStatus.textContent=`PNG pronto: ${format.width} × ${format.height} px.`;
  announce(`PNG gerado: ${format.width} × ${format.height}.`);
 }catch(e){exportStatus.textContent='Falha ao gerar PNG. Você ainda pode baixar SVG.';exportStatus.classList.add('error');announce('Falha na exportação. Tente SVG.',true);console.error('Exportação PNG:',e);}
 finally{exportGenerate.textContent='Baixar PNG';exportSetBusy(false);if(exportShareSupported)prepareExportShare(format);}
});
exportShare.addEventListener('click',()=>{
 // Os bytes já são preparados antes do toque, preservando a ativação exigida no iPhone/Android.
 const format=exportFormats.find(f=>f.id===exportSelected);
 if(!exportShareSupported||!format||exportBusy||exportShare.disabled||exportCachedId!==format.id)return;
 const job=exportCachedJob;
 // Compartilhar só é habilitado depois que o arquivo está pronto (Promise já resolvida).
 job.then(blob=>{
  if(exportOverlay.hidden||exportSelected!==format.id)return;
  const file=new File([blob],formatExportFilename(format),{type:'image/png'});
  if(!navigator.canShare({files:[file]})){exportStatus.textContent='Compartilhamento indisponível. Use Baixar PNG.';return;}
  const result=navigator.share({files:[file],title:'Resultados da APS'});
  Promise.resolve(result).then(()=>{exportStatus.textContent='Compartilhamento iniciado no dispositivo.';}).catch(e=>{
   if(e.name!=='AbortError'){exportStatus.textContent='Não foi possível compartilhar. Use Baixar PNG.';exportStatus.classList.add('error');}
  });
 }).catch(e=>{exportStatus.textContent='Não foi possível preparar o compartilhamento.';exportStatus.classList.add('error');console.error(e);});
});
// v1.0.15: tres pontos sobre a previa e botao Baixar sob Restaurar exemplo.
const posterMenuToggle=root.getElementById('posterMenuToggle');
const posterDropdown=root.getElementById('posterDropdown');
function setPosterMenu(open){
 posterDropdown.hidden=!open;
 posterMenuToggle.setAttribute('aria-expanded',String(open));
}
posterMenuToggle.addEventListener('click',()=>{
 const opening=posterDropdown.hidden;
 setPosterMenu(opening);
 if(opening)root.getElementById('posterMenuDownload').focus();
});
root.getElementById('posterMenuDownload').addEventListener('click',()=>{
 setPosterMenu(false);
 openExportDialog();
});
document.addEventListener('pointerdown',event=>{
 if(!posterDropdown.hidden&&!root.getElementById('posterMenuUI').contains(event.target))setPosterMenu(false);
});
document.addEventListener('keydown',event=>{
 if(event.key==='Escape'&&!posterDropdown.hidden){setPosterMenu(false);posterMenuToggle.focus();}
});
root.getElementById('btnPng').addEventListener('click',openExportDialog);
root.getElementById('exportClose').addEventListener('click',closeExportDialog);
root.getElementById('exportCancel').addEventListener('click',closeExportDialog);
exportOverlay.addEventListener('click',e=>{if(e.target===exportOverlay)closeExportDialog();});
document.addEventListener('keydown',e=>{
 if(exportOverlay.hidden)return;
 if(e.key==='Escape'){e.preventDefault();closeExportDialog();return;}
 if(e.key==='Tab'){
  const items=Array.from(exportDialog.querySelectorAll('button:not(:disabled)')).filter(btn=>!btn.hidden&&btn.getClientRects().length);
  if(!items.length)return;
  const first=items[0],last=items[items.length-1];
  if(e.shiftKey&&(document.activeElement===first||document.activeElement===exportDialog)){e.preventDefault();last.focus();}
  else if(!e.shiftKey&&(document.activeElement===last||document.activeElement===exportDialog)){e.preventDefault();first.focus();}
 }
});
// Os campos do cartaz são alimentados apenas por URL/API, não pelo editor.
root.querySelectorAll('#mapa,#legendas').forEach(el=>el.addEventListener('change',render));
root.getElementById('cirEnabled').addEventListener('change',()=>{syncCIRLayout(tema);render();});
// v1.0.16: parâmetros vindos da URL ou de integração, com exemplo fixo na ausência de dados.
// Classificação: 1 = ouro; 2 = prata; 3 = bronze; qualquer numero > 3 = neutro.
// "0" continua aceito como alias legado para o modo neutro.
function resolverTema(valor){
 const k=String(valor??'').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
 if(k && Number.isFinite(Number(k)) && Number(k)>3)return 'neutro';
 return ({'1':'ouro','ouro':'ouro','gold':'ouro','2':'prata','prata':'prata','silver':'prata',
  '3':'bronze','bronze':'bronze','0':'neutro','neutro':'neutro','neutral':'neutro'})[k]||null;
}
function normalizarChave(k){return String(k).normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-zA-Z0-9]/g,'').toLowerCase();}
function booleanoOpcional(valor){
 if(typeof valor==='boolean')return valor;
 const v=String(valor??'').trim().toLowerCase();
 if(['true','1','sim','yes','on'].includes(v))return true;
 if(['false','0','nao','não','no','off'].includes(v))return false;
 return null;
}
// v1.0.21: terceira referencia no formato /atencao_basica/CODIGO/cit/.
// v1.0.22: legenda explicativa adicionada acima de Cores do modelo.
// Exemplos: ?codigoPainel=220650, ?codigoPainel=251020, ?codigoPainel=251360.
// Compatibilidade: conasemsPath=251020/NOVAOLINDA e codigoIbge=2510202.
// Em codigos IBGE de 7 digitos, o ultimo digito verificador nao integra esta URL.
function atualizarReferenciaConasems(dados){
 let caminho=null, codigo=null, codigoIbge=null;
 for(const [chave,valor] of Object.entries(dados)){
  const k=normalizarChave(chave);
  if(['conasemspath','conasems','referenciaconasems'].includes(k)) caminho=String(valor??'').trim();
  if(['codigopainel','codigoconasems'].includes(k)) codigo=String(valor??'').trim();
  if(['codigoibge','codibge','ibge','codigomunicipio'].includes(k)) codigoIbge=String(valor??'').trim();
 }
 const recebido=caminho!==null?caminho:(codigo!==null?codigo:codigoIbge);
 if(recebido===null)return;
 // Apenas um codigo de 6 digitos (ou 7 com digito verificador),
 // aceitando o nome historico da cidade sem inseri-lo no endereco.
 const match=recebido.match(/^\/?(\d{6})(?:\d)?(?:\/[A-Za-z0-9_-]+)?\/?$/);
 if(!match){console.warn('Referência CONASEMS inválida: informe um código de município (ex.: 251020).');return;}
 const href=`https://paineis.conasems.org.br/atencao_basica/${match[1]}/cit/#secao-cofinanciamento`;
 const link=root.getElementById('refConasems');
 link.setAttribute('href',href);
 link.textContent=href;
}
window.atualizarCartazAPS = function(dados = {}) {
 // Compatibilidade retroativa com os nomes anteriores; aceita também chaves em snake_case e maiúsculas.
 const mapaCampos={
  municipio:'nome',nome:'nome',municipiouf:'nome',cidade:'nome',cidadeuf:'nome',
  competencia:'trimestre',trimestre:'trimestre',quadrimestre:'trimestre',
  meta:'percentual',percentual:'percentual',metaalcancada:'percentual',
  rankingregional:'ranking1',regional:'ranking1',destaqueregional:'ranking1',ranking1:'ranking1',
  rankingestadual:'ranking2',estadual:'ranking2',destaqueestadual:'ranking2',ranking2:'ranking2',
  rankingnacional:'ranking3',nacional:'ranking3',destaquenacional:'ranking3',ranking3:'ranking3',
  equipesregulares:'regular',regulares:'regular',regular:'regular',
  equipessuficientes:'suficiente',suficientes:'suficiente',suficiente:'suficiente',
  equipesboas:'boa',boas:'boa',boa:'boa',
  equipesotimas:'otima',otimas:'otima',otima:'otima'
 };
 let temaRecebido=null, temaExplicito=false;
 for(const [chave,valor] of Object.entries(dados)){
  const k=normalizarChave(chave);
  const campo=mapaCampos[k];
  if(campo){root.getElementById(campo).value=Array.isArray(valor)?valor.join('\n'):String(valor??'');continue;}
  if(['codigoibge','codibge','ibge','codigomunicipio'].includes(k)){
   codigoIbgeExport=String(valor??'').trim();
   continue;
  }
  if(['tema','classificacao','colocacao','premiacao'].includes(k)){
   temaExplicito=true;
   temaRecebido=resolverTema(valor);
  }
  if(['ouro','prata','bronze'].includes(k) && (String(valor)===({ouro:'1',prata:'2',bronze:'3'})[k])){
   if(!temaExplicito)temaRecebido=k;
  }
  if(['mapa','legendas','cir','compartilharcir'].includes(k)){
   const b=booleanoOpcional(valor);
   if(b!==null){const id=k==='mapa'?'mapa':k==='legendas'?'legendas':'cirEnabled';root.getElementById(id).checked=b;}
  }
 }
 if(temaRecebido)theme(temaRecebido);
 else syncCIRLayout(tema);
 atualizarReferenciaConasems(dados);
 render();return true;
};


  // Boot defaults (theme + first render) without reading URL — Vue supplies data.
  theme('ouro')
  render()

  return {
    atualizarCartazAPS: window.atualizarCartazAPS,
    theme,
    render,
    openExportDialog,
    closeExportDialog,
    setPosterMenu,
  }
}
